import Swal from "sweetalert2/dist/sweetalert2.js";

export default function () {
  /**
   * 表单验证错误消息弹框
   */
  const showValidateErrorMsg = () => {
    Swal.fire({
      text: "Sorry, looks like there are some errors detected, please check.",
      icon: "error",
      buttonsStyling: false,
      confirmButtonText: "Ok, got it!",
      customClass: {
        confirmButton: "btn btn-primary",
      },
    });
  };

  /**
   * 表单提交成功提示弹框
   */
  const showFormSubmitSuccessMsg = (callback?) => {
    Swal.fire({
      text: "Form has been successfully submitted!",
      icon: "success",
      buttonsStyling: false,
      confirmButtonText: "Ok, got it!",
      customClass: {
        confirmButton: "btn btn-primary",
      },
    }).then(() => {
      callback();
    });
  };

  /**
   * 显示服务端错误消息弹框
   */
  const showServerErrorMsg = (res) => {
    const errorMsg = res.data;
    let htmlMsg = "";
    if (errorMsg) {
      for (const key in errorMsg) {
        htmlMsg += errorMsg[key][0] + "<br/>";
      }
    }
    if (res.sub_code.indexOf("FORM-VALIDATION") != -1) {
      //服务端数据验证错误
      Swal.fire({
        title: res.sub_msg,
        icon: "error",
        html: htmlMsg,
      });
    } else {
      //服务端其他错误
      Swal.fire({
        title: res.msg,
        text: res.sub_msg,
        icon: "error",
      });
    }
  };

  return {
    showValidateErrorMsg,
    showFormSubmitSuccessMsg,
    showServerErrorMsg,
  };
}
